function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRoomTokyoTowerViewFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 4H4v24h24V4zM4 2a2 2 0 00-2 2v24a2 2 0 002 2h24a2 2 0 002-2V4a2 2 0 00-2-2H4z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.312 15c-.35-2.7-.312-5-.312-5h-2s0 2.3-.356 5h2.668zM9 27s3-3 4.5-7a17.2 17.2 0 00.601-2h3.764c.175.695.384 1.372.635 2 1.6 4 4.5 7 4.5 7h-2.625s-1.75-3-4.375-3-4.375 3-4.375 3H9zM15.5 5h1v3h-1V5z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 7h2v2h-2V7zM13 15h6l-.75 2h-4.5L13 15z",
    fill: props.color
  }));
}

export default SvgIconRoomTokyoTowerViewFilled;